'use client';

// UI components
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { ExtendedUser } from '@/types/next-auth';

export default function AvatarCont({ user }: { user: ExtendedUser }) {
  if (!user) return <>Loading</>;

  return (
    <div className="flex items-center space-x-2" aria-label="User">
      <Avatar className="min-h-4 min-w-4">
        <AvatarImage src={user.image!} alt={user.name!} />
        <AvatarFallback className="font-semibold">
          {user
            .name!.split(' ')
            .map((n) => n[0])
            .join('')
            .toUpperCase()}
        </AvatarFallback>
      </Avatar>

      <div className="grow">
        <h2 className="text-sm font-semibold">{user.name}</h2>
        <p className="text-xs font-normal text-muted-foreground">
          {user.email}
        </p>
      </div>
    </div>
  );
}
